angular.module("iconoglobe").directive("onImageLoad", [function () {
    return {
        restrict: 'A',
        scope:{
            onImageLoad:"&"
        },
        link: function(scope, element, attrs) {
            element.bind('load', function() {
                //call the function that was passed
                scope.onImageLoad()
            });
        }
    };
}]);